const colores = {
    primario: "#053465",
    secundario: "#307FE2",
};

export default colores;
